module.exports = __webpack_public_path__ + "img/logo.e880c795.png";